let readMore = document.getElementById('client-grid-read-more');
let teamGrid = document.getElementById('client-grid');

if(readMore) {
    readMore.addEventListener('click', function() {
        teamGrid.style.maxHeight = teamGrid.scrollHeight + "px";
        readMore.remove();
    })
}